import { FilterValues } from "./FilterValuesCollection";
import { assert } from "@/common/assert";

export class ApplyFilterEvent extends Event {
    public static readonly Type = "filter";

    constructor() {
        super(ApplyFilterEvent.Type);
    }
}

export default new class ApplyFilterButtonService extends EventTarget {
    private filterValues: FilterValues | undefined;

    public applySelectedFilters(filterValues: FilterValues): void {
        this.filterValues = filterValues;
        this.dispatchEvent(new ApplyFilterEvent());
    }

    public getFilterValues(): FilterValues {
        assert(this.filterValues !== undefined);

        return this.filterValues;
    }
}();
